import { useRouter } from "next/router";
import { Container, Col, Row } from "reactstrap";
import styles from "./styles.module.scss";
import JobSearch from "@sourceflow-uk/job-search";
import "@sourceflow-uk/job-search/dist/bundle.css";
import useRegion from "@/hooks/useRegion";
import useJobs from "@/hooks/useJobs";
import JobCard from "@/components/JobCard";

// JOB FILTERS - UK
import sectorsUK from "@/.sourceflow/jobs-sectors_uk.json";
import jobsTypesUK from "@/.sourceflow/jobs-job_types.json";
import baseSalaryRangeUK from "@/.sourceflow/jobs-uk_base_salary_range.json";
import workType from "@/.sourceflow/jobs-work_type.json";
import regionUK from "@/.sourceflow/jobs-Region.json";

// JOB FILTERS - US
import sectorsUS from "@/.sourceflow/jobs-sectors_us.json";
import jobsTypesUS from "@/.sourceflow/jobs-job_type_us.json";
import baseSalaryRangeUS from "@/.sourceflow/jobs-us_base_salary_range.json";
import workTypeUS from "@/.sourceflow/jobs-work_type_us.json";

export const JobsFeed = ({ className, title, subTitle, heading }) => {
  const { asPath } = useRouter();
  const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

  const region = useRegion();
  const filterRegions = region
      .filter(item => locale === "/us/" ? item.country === 'United States' : item.country !== 'United States')
      .map(item => item.id);

  const totalJobs = useJobs({ limit: null, regionFilters: filterRegions });

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <JobSearch
          options={{
            urlFilters: {
              mode: "active",
              jobCategories: [
                // UK
                sectorsUK,
                jobsTypesUK,
                baseSalaryRangeUK,
                workType,
                regionUK,

                // US
                sectorsUS,
                jobsTypesUS,
                baseSalaryRangeUS,
                workTypeUS,
              ],
              pushToHistoryOnSearch: true,
              changeURLOnFilterChange: true,
            },
            jobsUrl: `${locale ? locale : ""}jobs`,
            jobsPerPage: 10,
            searchFilters: true,
            submitDestination: null,
            performInitialSearch: true,
            searchSubmitButton: false,
            searchInput: false,
            prefilters: {
              // Filter jobs by Region
              "b4b8be3c-ba95-4912-aa85-2cbc1264449d": filterRegions,
            },
            searchFiltersOptions: {
              showResetSearchButton: true,
              topLevelCategoryOrder: ["Sectors", "US - Sectors", "Salary Range", "US - Salary Range", "Region", "Job Type", "US - Job Type", "Work Type", "US - Work Type"],
              filterShowCount: false,
              initialFilterOpenState: false,
              categorySort: {
                Expertise: { key: "name", direction: "asc" },
                // Sectors
                "6201aa1d-bc28-452d-8f5c-9146fa604872": {
                  key: "name",
                  direction: "asc",
                },
                // US - Sectors
                "e937d6f2-07a3-4ac7-bf04-0324eda2eee8": {
                  key: "name",
                  direction: "asc",
                },
                // Region
                "b4b8be3c-ba95-4912-aa85-2cbc1264449d": {
                  key: "name",
                  direction: "asc",
                },
                // Job Type
                "87757283-767f-4224-85d3-986ac52dc4c5f": {
                  key: "name",
                  direction: "asc",
                },
                // US - Job Type
                "40ca310c-7a77-40c9-97a3-ce605715e6e8": {
                  key: "name",
                  direction: "asc",
                },
                // Work Type
                "06094d46-4239-4a9d-8149-455c145e7bb0": {
                  key: "name",
                  direction: "asc",
                },
                "US Base Salary Range": function (a, b) {
                  const matchA = a.name.match(/\$([\d,]+)(?:-\d+k)?/);
                  const matchB = b.name.match(/\$([\d,]+)(?:-\d+k)?/);
                  if (!matchA && !matchB) return a.name.localeCompare(b.name);
                  if (!matchA) return 1;
                  if (!matchB) return -1;
                  return parseInt(matchA[1].replace(/,/g, ""), 10) - parseInt(matchB[1].replace(/,/g, ""), 10);
                },
                "Salary Range": function (a, b) {
                  const matchA = a.name.match(/^£([\d,]+)/);
                  const matchB = b.name.match(/^£([\d,]+)/);
                  if (!matchA && !matchB) return a.name.localeCompare(b.name);
                  if (!matchA) return 1;
                  if (!matchB) return -1;
                  return parseInt(matchA[1].replace(/,/g, ""), 10) - parseInt(matchB[1].replace(/,/g, ""), 10);
                },
              },
            },
            searchResults: ({ results }) =>
              results?.length >= 1 ? (
                <>
                  <div className="mb-4">
                    {title && <h2 className={heading}>Jobs Found</h2>}
                    <p className="text-muted">
                      {subTitle || `Showing ${totalJobs?.length} vacancies`}
                    </p>
                  </div>
                  <Row>
                    {results.map(({ job }) => (
                      <Col xs={12} key={job.id} className="mb-4">
                        <JobCard
                          {...job}
                          post_lang={locale}
                          published_at={job.published_at * 1000}
                        />
                      </Col>
                    ))}
                  </Row>
                </>
              ) : (
                <>
                  <p>
                    Sorry, we couldn't find any jobs matching your search.
                    Please try removing some filters or searching for something
                    else.
                  </p>
                </>
              ),
          }}
        />
      </Container>
    </section>
  );
};

export default JobsFeed;
